import { render } from "./yuan.vue?vue&type=template&id=17515491"
import script from "./yuan.vue?vue&type=script&lang=ts"
export * from "./yuan.vue?vue&type=script&lang=ts"
script.render = render

export default script